
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import demo from './demo/demo.twig';
import logos from './demo/logos.json';
const justifyOptions = ['start', 'center', 'end'];
const demoTemplateSource = (_src, storyContext) => {
  const args = storyContext.args || storyContext.initialArgs;
  const twigArgs =
    Object.keys(args).length > 0
      ? ` with ${JSON.stringify(args, null, 2)}`
      : '';
  return `{% embed '@cloudfour/objects/logo-group/logo-group.twig'${twigArgs} %}
  {% block content %}
    {# logos #}
  {% endblock %}
{% endembed %}`;
};
const demoStory = (args) => demo({ ...args, logos });


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Logo Group" parameters={{
      docs: {
        transformSource: demoTemplateSource
      }
    }} argTypes={{
      justify: {
        options: justifyOptions,
        control: {
          type: 'inline-radio'
        }
      },
      pad: {
        type: {
          name: 'boolean'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Logo Group`}</h1>
    <p>{`The Logo Group presents multiple logos together with consistent spacing and alignment. It is useful for summarizing a list of projects or clients.`}</p>
    <p>{`To fine-tune the relative scale or layout of individual logos within, consider using `}<a parentName="p" {...{
        "href": "/docs/components-logo--basic-options"
      }}>{`the Logo component`}</a>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Default" mdxType="Story">{args => demoStory(args)}</Story>
    </Canvas>
    <h2>{`Options`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`justify`}</inlineCode>{` template property or `}<inlineCode parentName="p">{`o-logo-group--justify-{alignment}`}</inlineCode>{` class sets the horizontal alignment of the logos within the group. The default is `}<inlineCode parentName="p">{`start`}</inlineCode>{`, but `}<inlineCode parentName="p">{`center`}</inlineCode>{` and `}<inlineCode parentName="p">{`end`}</inlineCode>{` are also supported.`}</p>
    <p>{`To repeat the gap between logos around the whole container, set the `}<inlineCode parentName="p">{`pad`}</inlineCode>{` template property to `}<inlineCode parentName="p">{`true`}</inlineCode>{` or apply the `}<inlineCode parentName="p">{`o-logo-group--pad`}</inlineCode>{` modifier class.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Centered with padding" args={{
        justify: 'center',
        pad: true
      }} mdxType="Story">
    {args => demoStory(args)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const defaultStory = (args => demoStory(args));
defaultStory.storyName = 'Default';
defaultStory.parameters = { storySource: { source: 'args => demoStory(args)' } };

export const centeredWithPadding = (args => demoStory(args));
centeredWithPadding.storyName = 'Centered with padding';
centeredWithPadding.args = {
  justify: 'center',
  pad: true
};
centeredWithPadding.parameters = { storySource: { source: 'args => demoStory(args)' } };

const componentMeta = { title: 'Objects/Logo Group', parameters: {
  docs: {
    transformSource: demoTemplateSource
  }
}, argTypes: {
  justify: {
    options: justifyOptions,
    control: {
      type: 'inline-radio'
    }
  },
  pad: {
    type: {
      name: 'boolean'
    }
  }
}, includeStories: ["defaultStory","centeredWithPadding"],  };

const mdxStoryNameToKey = {"Default":"defaultStory","Centered with padding":"centeredWithPadding"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;